// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"09ab8b77","198":"a1f0ce4e","573":"8b20565a"}[chunkId] + ".chunk.css";
};